import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CopyContentButtonComponent } from '@seahorse/ui';

/**
 * Code/ID table cell (design handoff, "Data table pattern"): tabular
 * numerals, with an optional copy button. The copy behaviour and
 * notification are `sh-copy-content-button` (`@seahorse/ui`), which
 * super-user's customers page already uses for organisation IDs today --
 * `shell` can't depend on `@seahorse/common` directly (module boundary
 * rule), so this reuses the existing component rather than its service.
 * Standalone, no styles of its own -- see `.cell-code*` in
 * `@seahorse/theme`'s `_table.scss`.
 */
@Component({
  selector: 'sh-cell-code',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CopyContentButtonComponent],
  template: `
    <span class="cell-code">
      <span class="cell-code-value">{{ value() }}</span>
      <sh-copy-content-button
        *ngIf="copy()"
        [content]="value()"
      ></sh-copy-content-button>
    </span>
  `,
})
export class CellCodeComponent {
  value = input.required<string>();
  copy = input(false);
}
